import { useState } from 'react';
import { axiosInstance } from "../services/axiosConfig";
import { BASE_URL } from "../utility/constants";

const useCreateStudentSelfOnboarding = () => {
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const API_URL = `${BASE_URL}v2/students`;

    const createStudent = async (
        name,
        grade,
        email,
        institute_code,
        client,
        dob,
        response_id,
        client_id,
        phone,
        division,
        coupon_code
    ) => {
        setIsLoading(true);
        const requestBody = {
            name,
            grade,
            email,
            institute_code,
            client,
            dob,
            response_id,
            client_id,
            phone,
            division,
            coupon_code
        };

        try {
            const res = await axiosInstance.post(API_URL, requestBody);
            setResponse(res.data);
            setError(null);
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    return { response, error, isLoading, createStudent };
};

export default useCreateStudentSelfOnboarding;
